import type { ColorByOption } from 'components/color-by-attribute-modal';

/**
 * The attribute id for "Wellbore Geometry", kept here so the option list, the pickers
 * and the painters all agree on one key.
 */
export const WELLBORE_GEOMETRY_ATTRIBUTE = 'wellboreGeometry';

/**
 * What a colour rule on Wellbore Geometry can name — mock v13's four values.
 *
 * These name a kind of trace, not a well, and one well draws several at once. So the
 * painters resolve this attribute from the trace being drawn rather than the well's
 * own fields, and a rule on it colours a producing bore differently from its sidetracks.
 */
export const WELLBORE_GEOMETRY_KINDS = {
  completion: 'Completion UWI14',
  perforatedInterval: 'Perforated Interval',
  preDrill: 'Pre-Drill Wellbore Geometry',
  sidetrack: 'Sidetracks',
} as const;

export type WellboreGeometryKind = keyof typeof WELLBORE_GEOMETRY_KINDS;

/**
 * The values offered for Wellbore Geometry, in the mock's order.
 * @return {ColorByOption[]} The four trace kinds.
 */
export const wellboreGeometryOptions = (): ColorByOption[] =>
  Object.entries(WELLBORE_GEOMETRY_KINDS).map(([id, name]) => ({ id, name }));
